'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { IconChevronRight } from '../../../svg/icons/icon-chevron-right.js';
import { MobileFullPageMenu } from './mobile-full-page-menu.js';
import { MobileLink } from './mobile-link.js';
import { MobileTakeover } from './mobile-takeover.js';

const MobileNestedNav = ({ containerVisible, entry, closeContainer, }) => {
    const [open, setOpen] = useState(false);
    useEffect(() => {
        if (!containerVisible) {
            setOpen(false);
        }
    }, [containerVisible]);
    return (jsxs(Fragment, { children: [jsx(MobileLink, { className: "flex w-full items-center justify-between text-2xl", entry: {
                    ...entry,
                    onClick: () => setOpen(true),
                    RightIcon: IconChevronRight,
                } }), jsx(MobileTakeover, { open: open, children: jsx(MobileFullPageMenu, { open: true, onClick: () => setOpen(false), children: jsx("div", { className: "flex flex-col gap-5 py-6", children: entry.childEntries?.map((link) => (jsx(MobileLink, { className: "text-left text-xl", entry: link, onNavigate: closeContainer }, link.label))) }) }) })] }));
};

export { MobileNestedNav };
//# sourceMappingURL=mobile-nested-nav.js.map
